export const BUY_GUIDE_HINTS = {
  selectAccount: {
    id: "select-account",
    step: 2,
    title: "Select Account",
    description:
      "Select the account you want to buy crypto from. I'll help make the process smooth and secure.",
    position: "left",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "bottom",
  },
  selectAsset: {
    id: "select-asset",
    step: 3,
    title: "Select Asset",
    description:
      "Explore supported crypto assets and choose the one you'd like to transact with.",
    position: "right",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "top",
  },
  enterAmount: {
    id: "enter-amount",
    step: 4,
    title: "Enter Amount",
    description:
      "Enter the amount you'd like to buy. Monfi will instantly calculate the crypto value for you.",
    position: "left",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "below",
  },
  confirmOrder: {
    id: "confirm-order",
    step: 5,
    title: "Confirm Order",
    description:
      "Review your transaction details and confirm your crypto purchase securely.",
    position: "right",
    secondaryAction: "skip",
    inlineOnMobile: true,
    mobilePlacement: "top",
  },
  purchaseComplete: {
    id: "purchase-complete",
    title: "Purchase is complete! 🎉",
    useStepPrefix: false,
    description:
      "Your crypto purchase was successful and your assets are now available in your portfolio.",
    position: "left",
    primaryAction: "done",
    secondaryAction: "depositCrypto",
    inlineOnMobile: true,
    mobilePlacement: "bottom",
  },
};
